<template>
  <section id="mainContainer">
    <adminHeader></adminHeader>
    <section class="admin-mid-container">
      <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
        <adminNavigation></adminNavigation>
        <section class="admin-right-sidebar">
          <div class="admin-right-sidebar-in">
            <div class="admin-right-sidebar-in-top">
              <div class="admin-custom-row">
                <div class="admin-right-sidebar-in-top-left">
                  <h1>
                    {{ constants.MANAGE_JOB_CATEGORIES_TEXT }} ({{ counts }})
                  </h1>
                </div>
                <div class="admin-right-sidebar-in-top-right">
                  <div class="admin-right-sidebar-in-top-right-top">
                    <div class="admin-search-box">
                      <input
                        id="searchJobCateInput"
                        type="text"
                        placeholder="Search"
                        v-model="searchedText"
                        @keyup.enter="
                          fetchJobCategories(limit, skip),
                            fetchCounts(searchedText)
                        "
                      />
                    </div>
                    <div class="admin-add-btn">
                      <button
                        id="addNewJobCateBtn"
                        class="add-btn-admin"
                        :class="{ active: showAddForm }"
                        @click="
                          (showAddForm = true),
                            (selectedJobCategories = []),
                            (selectAll = false),
                            cancelEdit()
                        "
                      >
                        <i class="add-icon"></i>
                        {{ constants.ADD_JOB_CATEGORY_BUTTON }}
                      </button>
                    </div>
                  </div>
                  <div
                    class="admin-right-sidebar-in-top-right-btm"
                    v-if="selectedJobCategories.length > 1"
                  >
                    <div class="tags">
                      <ul>
                        <li>
                          <span
                            >{{ selectedJobCategories.length }} entries
                            selected</span
                          >
                          <button
                            id="tagCloseBtn"
                            @click="
                              (selectedJobCategories = []), (selectAll = false)
                            "
                          ></button>
                        </li>
                      </ul>
                    </div>
                    <div class="delete-all-btn-link">
                      <button
                        class="btn_link"
                        id="deleteAllBtn"
                        data-bs-toggle="modal"
                        data-bs-target="#deletePop"
                        @click="setDeleteMode('all')"
                      >
                        {{ constants.DELETE_ALL_BUTTON }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showAddForm" class="white-bg-border add-new-section">
              <div class="add-banner-image-section">
                <h2>
                  {{ constants.ADD_NEW_CATEGORY_TEXT }}
                </h2>
                <div class="add-banner-image-box">
                  <form id="addJobForm" @submit.prevent="submitForm">
                    <div class="admin-input-field">
                      <label>
                        {{ constants.CATEGORY_TITAL_LABEL }}
                      </label>
                      <input
                        id="jobCateTitleInput"
                        type="text"
                        placeholder="Enter the Title"
                        v-model="newJobCategorie.title"
                      />
                      <div class="error-msg" v-if="!newJobCategorie.title">
                        {{ errMsg }}
                      </div>
                    </div>

                    <div class="admin-input-field">
                      <label>
                        {{ constants.ACTIVE_INACTIVE_LABEL }}
                      </label>
                      <div
                        class="active-inactive-radio"
                        @click="toggleStatus(false)"
                      >
                        <input
                          id="ActiveInput"
                          type="radio"
                          name="foo"
                          class="active-radio"
                          v-model="newJobCategorie.status"
                          :value="1"
                        />
                        <input
                          id="InactiveInput"
                          type="radio"
                          name="foo"
                          class="inactive-radio"
                          v-model="newJobCategorie.status"
                          :value="0"
                        />
                        <div class="active-inactive-radio-img"></div>
                      </div>
                    </div>

                    <div class="admin-input-field-submit">
                      <button
                        id="jobCateSubmitBtn"
                        class="admin-btn-outline-primary"
                        type="submit"
                        :disabled="isSubmitting"
                      >
                        {{ constants.SUBMIT_BUTTON }}
                      </button>
                      <button
                        class="admin-btn-outline-secondary add-new-cancel"
                        type="button"
                        id="jobCateCancleBtn"
                        @click="resetForm"
                      >
                        {{ constants.CANCEL_BUTTON }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              :class="[
                'admin-item-list-section admin-jobs-category-section',
                { 'show-edit-item-outer': editFormSubmitted },
              ]"
              v-if="editJobCategoriesData.length > 0"
            >
              <div
                class="admin-item-list-section-in"
                ref="scrollWrapper"
                data-simplebar
              >
                <div class="admin-item-list-section-scroll">
                  <div class="admin-item-list-top">
                    <div class="admin-item-list-row">
                      <div class="admin-item-checkbox">
                        <div class="admin-checkbox-input">
                          <input
                            name="cssCheckbox"
                            id="selectAll"
                            type="checkbox"
                            class="css-checkbox"
                            @change="toggleSelectAll"
                            :checked="selectAll === true"
                          />
                          <label for="selectAll"></label>
                        </div>
                      </div>

                      <div
                        class="admin-item-jobs-category-title"
                        @click="toggleSort('title')"
                        style="cursor: pointer"
                      >
                        {{ constants.TITLE_LABEL }}
                        <button
                          v-if="sortBy === 'title' || sortBy === '-title'"
                          class="sorting-btn"
                          :class="{ sorted: sortBy === '-title' }"
                        ></button>
                      </div>

                      <div class="admin-item-jobs-category-active-inactive">
                        {{ constants.ACTIVE_INACTIVE_LABEL }}
                      </div>

                      <div class="admin-item-sm-actions">
                        {{ constants.ACTIONS_LABEL }}
                      </div>
                    </div>
                  </div>

                  <div class="admin-item-list-btm">
                    <div ref="sortableList">
                      <div
                        v-for="(jobCategorie, index) in editJobCategoriesData"
                        :key="jobCategorie.id"
                        :class="[
                          'admin-item-box',
                          { 'show-edit-item': jobCategorie.editing },
                        ]"
                      >
                        <div class="admin-item-box-top">
                          <div class="admin-item-list-row">
                            <div class="admin-item-checkbox">
                              <div class="admin-checkbox-input">
                                <input
                                  name="cssCheckbox"
                                  :id="'demo_opt_' + jobCategorie.id"
                                  type="checkbox"
                                  class="css-checkbox"
                                  @change="
                                    toggleJobCategorieSelection(jobCategorie.id)
                                  "
                                  :checked="
                                    selectedJobCategories.includes(
                                      jobCategorie.id
                                    )
                                  "
                                />
                                <label
                                  :for="'demo_opt_' + jobCategorie.id"
                                ></label>
                              </div>
                            </div>
                            <div class="admin-item-jobs-category-title">
                              {{ jobCategorie.title }}
                            </div>
                            <div
                              class="admin-item-jobs-category-active-inactive"
                            >
                              <div class="category-active-inactive-img">
                                <div
                                  class="active-inactive-radio"
                                  @click="
                                    changeJobCategorieStatus(
                                      jobCategorie.id,
                                      jobCategorie.status
                                    )
                                  "
                                >
                                  <input
                                    type="radio"
                                    id="ActiveInput"
                                    :name="'status_' + jobCategorie.id"
                                    class="active-radio"
                                    :value="1"
                                    v-model="jobCategorie.status"
                                  />
                                  <input
                                    type="radio"
                                    id="InActiveInput"
                                    :name="'status_' + jobCategorie.id"
                                    class="inactive-radio"
                                    :value="0"
                                    v-model="jobCategorie.status"
                                  />
                                  <div class="active-inactive-radio-img"></div>
                                </div>
                              </div>
                            </div>

                            <div class="admin-item-sm-actions">
                              <ul class="admin-action-link">
                                <li>
                                  <button
                                    id="jobCatePgEditBtn"
                                    class="editBtn"
                                    @click="
                                      editJobCategorie(index),
                                        (showAddForm = false)
                                    "
                                  >
                                    {{ constants.EDIT_BUTTON }}
                                  </button>
                                </li>
                                <li>
                                  <button
                                    data-bs-toggle="modal"
                                    id="jobCatePgDeleteBtn"
                                    data-bs-target="#deletePop"
                                    @click="
                                      setDeleteMode('single', jobCategorie.id),
                                        (showAddForm = false),
                                        cancelEdit()
                                    "
                                  >
                                    {{ constants.DELETE_BUTTON }}
                                  </button>
                                </li>
                              </ul>
                            </div>
                            <div class="clear"></div>
                          </div>
                        </div>
                        <div
                          class="admin-item-box-btm"
                          v-if="jobCategorie.editing"
                        >
                          <div class="add-banner-image-section">
                            <h2>
                              {{ constants.EDIT_JOB_CATEGORIES_TEXT }}
                            </h2>
                            <div class="add-banner-image-box">
                              <div class="admin-input-field">
                                <label>
                                  {{ constants.CATEGORY_TITAL_LABEL }}
                                </label>
                                <input
                                  id="jobCateTitleInput"
                                  type="text"
                                  placeholder="Enter the Title"
                                  v-model="editJobCategorieData.title"
                                />
                                <div
                                  class="error-msg"
                                  v-if="!editJobCategorieData.title"
                                >
                                  {{ errEditMsg }}
                                </div>
                              </div>

                              <div class="admin-input-field">
                                <label>
                                  {{ constants.ACTIVE_INACTIVE_LABEL }}
                                </label>
                                <div
                                  class="active-inactive-radio"
                                  @click="toggleStatus(true)"
                                >
                                  <input
                                    id="ActiveInput"
                                    type="radio"
                                    class="active-radio"
                                    name="fuu"
                                    v-model="editJobCategorieData.status"
                                    :value="1"
                                  />
                                  <input
                                    id="InactiveInput"
                                    type="radio"
                                    name="fuu"
                                    class="inactive-radio"
                                    v-model="editJobCategorieData.status"
                                    :value="0"
                                  />
                                  <div class="active-inactive-radio-img"></div>
                                </div>
                              </div>
                              <div class="admin-input-field-submit">
                                <button
                                  id="jobCateSubmitBtn"
                                  class="admin-btn-outline-primary"
                                  @click="submitEditForm(jobCategorie.id)"
                                >
                                  {{ constants.SUBMIT_BUTTON }}
                                </button>
                                <button
                                  id="jobCateCancleBtn"
                                  class="admin-btn-outline-secondary addNewCancel"
                                  @click="cancelEdit"
                                >
                                  {{ constants.CANCEL_BUTTON }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="admin-pagination-section">
                <div class="custom-row">
                  <div class="item-show-selectbox">
                    <select
                      id="paginationSelectBox"
                      v-model="limit"
                      @change="handleLimitChange"
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    <span> {{ constants.ENTRIES_PER_PAGE_LABEL }}</span>
                  </div>
                  <div
                    class="admin-pagination"
                    id="paginationBox"
                    v-if="totalPages > 1"
                  >
                    <ul>
                      <li
                        v-if="currentPage !== 1"
                        @click="changePage(currentPage - 1)"
                      >
                        <a href="#" class="pagination-previous"></a>
                      </li>
                      <li
                        v-for="page in visiblePages"
                        :key="page"
                        @click="changePage(page)"
                        v-if="totalPages != 1"
                      >
                        <a href="#" :class="{ active: currentPage === page }">{{
                          page
                        }}</a>
                      </li>
                      <li
                        v-if="currentPage !== totalPages"
                        @click="changePage(currentPage + 1)"
                      >
                        <a href="#" class="pagination-next"></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p>No data to display</p>
            </div>
          </div>
        </section>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">
        {{ constants.COPYRIGHT_TEXT }}
      </div>
    </footer>
    <div
      class="modal fade confirmation-popup"
      id="deletePop"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="confirmation-popup-icon">
            <i>
              <img
                src="@/assets/images/admin-img/light_delete-outline.svg"
                alt=""
              />
            </i>
          </div>
          <div class="confirmation-popup-mid">
            <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
          </div>
          <div class="confirmation-popup-btm">
            <button
              id="popNoBtn"
              class="admin-btn-outline-secondary"
              data-bs-dismiss="modal"
            >
              {{ constants.NO_BUTTON }}
            </button>
            <button
              id="popYesBtn"
              class="admin-btn-outline-primary"
              data-bs-dismiss="modal"
              @click="confirmDelete"
            >
              {{ constants.YES_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, nextTick } from "vue";
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from "axios";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from "sweetalert2";
import { API_BASE_URL } from "@/config/api.config";
import Sortable, { SortableEvent } from "sortablejs";
import {
  getPaginationLimit,
  setPaginationLimit,
} from "@/utils/paginationUtils";

interface JobCategorie {
  id: number;
  title: string;
  status: number;
  editing?: boolean;
  Created_at?: string;
  position: number; // Add position field
}

export default defineComponent({
  name: "Job-Categorie",
  data() {
    return {
      constants,
      status: 1,
      skip: 0,
      errMsg: "",
      errEditMsg: "",
      searchTempVar: "",
      showAddForm: false,
      limit: 10,
      selectAll: false,
      editFormSubmitted: false,
      jobCategories: [] as JobCategorie[],
      editJobCategoriesData: [] as JobCategorie[],
      selectedJobCategories: [] as number[],
      totalPages: 0,
      currentPage: 1,
      searchedText: "",
      counts: 0,
      newJobCategorie: {
        title: "",
        status: 0,
      },
      editJobCategorieData: {
        title: "",
        status: 0,
      },
      jobCategorieToDelete: null as number | null,
      deleteMode: "all" as "all" | "single",
      parmaSubmitted: false,
      isSubmitting: false,
      isDragging: false, // Add for drag state
      sortableInstance: null as Sortable | null,
      sortBy: "-position" as string,
    };
  },
  beforeRouteEnter(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      next({ name: "Login" });
    } else {
      next();
    }
  },
  computed: {
    visiblePages() {
      const maxVisiblePages = 5;
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
      let end = start + maxVisiblePages - 1;

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  components: {
    adminHeader,
    adminNavigation,
  },
  created() {
    this.limit = getPaginationLimit("jobCategory", 10);
    this.fetchCounts();
    this.fetchJobCategories();
  },

  mounted() {
    this.setupSortable(); // Initialize SortableJS on mount
  },

  methods: {
    setDeleteMode(mode: any, jobCategorieId?: number) {
      this.deleteMode = mode;
      if (jobCategorieId !== undefined) {
        this.jobCategorieToDelete = jobCategorieId;
      }
    },
    confirmDelete() {
      if (this.deleteMode === "all") {
        this.deleteSelectedContacts();
      } else if (this.deleteMode === "single") {
        this.deleteJobCategorie();
      }
    },
    changePage(page: number) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchJobCategories(
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        this.selectAll = false;
        this.selectedJobCategories = [];
      }
    },
    toggleJobCategorieSelection(jobCategorieId: number) {
      if (this.selectedJobCategories.includes(jobCategorieId)) {
        this.selectedJobCategories = this.selectedJobCategories.filter(
          (id) => id !== jobCategorieId
        );
      } else {
        this.selectedJobCategories.push(jobCategorieId);
      }
    },
    toggleSelectAll() {
      if (this.selectAll === true) {
        this.selectedJobCategories = [];
        this.selectAll = false;
      } else {
        this.selectedJobCategories = this.editJobCategoriesData.map(
          (jobCategorie) => jobCategorie.id
        );
        this.selectAll = true;
      }
    },

    async submitForm() {
      if (!this.newJobCategorie.title) {
        this.errMsg = "This Field Is Required";
        return;
      }
      this.isSubmitting = true;
      const formData = new FormData();
      formData.append("title", this.newJobCategorie.title);
      formData.append("status", this.newJobCategorie.status.toString());
      try {
        const response = await fetch(`${API_BASE_URL}/jobcategory/`, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        this.editJobCategoriesData = [data, ...this.editJobCategoriesData];
        this.counts = (this.counts || 0) + 1;
        this.resetForm();
        this.errMsg = "";
        Swal.fire({
          icon: "success",
          title: "Job Categorie Created Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        console.error("Error submitting jobCategorie:", error);
      } finally {
        this.isSubmitting = false; // Re-enable the button
      }
    },
    async deleteSelectedContacts() {
      try {
        await axios.delete(`${API_BASE_URL}/jobcategory/bulk_delete/`, {
          data: { ids: this.selectedJobCategories },
        });
        this.editJobCategoriesData = this.editJobCategoriesData.filter(
          (jobCategorie) =>
            !this.selectedJobCategories.includes(jobCategorie.id)
        );
        this.selectedJobCategories = [];
        this.fetchJobCategories();
        if (this.editJobCategoriesData.length === 0) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage < 1) {
            this.currentPage = 1;
          }
          this.fetchJobCategories();
          this.selectAll = false;
          this.fetchCounts();
        }
      } catch (error) {
        console.error("Error deleting contacts:", error);
      }
    },
    async submitEditForm(jobCategorieId: number) {
      if (!this.editJobCategorieData.title) {
        this.errEditMsg = "This Field Is Required";
        return;
      }
      const formData = new FormData();
      formData.append("title", this.editJobCategorieData.title);
      formData.append("status", this.editJobCategorieData.status.toString());

      try {
        const response = await axios.patch(
          `${API_BASE_URL}/jobcategory/${jobCategorieId}/`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        const index = this.editJobCategoriesData.findIndex(
          (cat) => cat.id === jobCategorieId
        );
        if (index !== -1) {
          this.editJobCategoriesData[index] = {
            ...this.editJobCategoriesData[index],
            title: this.editJobCategorieData.title,
            status: this.editJobCategorieData.status,
          };
          this.editJobCategoriesData = [...this.editJobCategoriesData];
        }
        this.cancelEdit();
        this.parmaSubmitted = true;
        Swal.fire({
          icon: "success",
          title: "Job Category Updated Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
        if (this.sortBy !== "-position" || this.searchedText) {
          await this.fetchJobCategories(
            this.limit,
            (this.currentPage - 1) * this.limit,
            this.sortBy
          );
        }
      } catch (error) {
        console.error("Error updating job category:", error);
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Failed to update job category.",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    handleLimitChange() {
      setPaginationLimit("jobCategory", this.limit);
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.counts / this.limit);
      this.selectAll = false;
      this.selectedJobCategories = [];
      this.fetchJobCategories(this.limit);
    },
    // @ts-expect-error
    async fetchJobCategories(limit = 10, skip = 0, sortBy = this.sortBy) {
      let url = `${API_BASE_URL}/jobcategory/`;
      const params = new URLSearchParams();
      if (this.searchedText) {
        if (!this.searchTempVar) {
          this.limit = 10;
          this.currentPage = 1;
        }
        this.searchTempVar = this.searchedText;
      }
      if (!this.searchedText) {
        if (this.searchTempVar) {
          this.currentPage = 1;
          this.limit = 10;
          this.searchTempVar = "";
        }
        params.append("limit", limit.toString());
        params.append("skip", skip.toString());
      }
      if (this.searchedText) {
        params.append("limit", this.limit.toString());
        params.append("skip", skip.toString());
        params.append("searchedText", this.searchedText);
      }
      params.append("sort_by", sortBy); // Sort by position by default
      try {
        const response = await axios.get(`${url}?${params.toString()}`);
        this.editJobCategoriesData = response.data;
        await this.fetchCounts(this.searchedText);
        this.totalPages = Math.ceil(this.counts / this.limit);
        this.$nextTick(() => this.setupSortable());
      } catch (error) {
        console.error("Error fetching jobCategories:", error);
      }
    },
    // async switchView() {
    //   this.totalPages = Math.ceil(this.counts / this.limit);
    //   this.currentPage = 1;
    //   this.selectedJobCategories = [];
    //   this.selectAll = false;
    //   this.editFormSubmitted = false;
    //   this.sortBy = "-position";
    //   await this.fetchJobCategories();
    // },
    async fetchCounts(searchedText?: string) {
      try {
        const baseUrl = `${API_BASE_URL}/jobcategory/count/`;
        const queryParam = searchedText ? `?searchedText=${searchedText}` : "";
        const response = await axios.get(`${baseUrl}${queryParam}`);
        this.counts = response.data.count;
        // this.switchView();
      } catch (error) {
        console.error("Error fetching jobCategorie counts:", error);
      }
    },

    editJobCategorie(index: number) {
      this.editJobCategoriesData.forEach((jobCategorie, i) => {
        jobCategorie.editing = i === index;
      });
      this.editFormSubmitted = true;
      const selectedJobCategorie = this.editJobCategoriesData[index];
      this.editJobCategorieData = {
        title: selectedJobCategorie.title,
        status: selectedJobCategorie.status,
      };
      if (this.sortableInstance) {
        this.sortableInstance.option("disabled", true);
      }
    },

    resetForm() {
      this.newJobCategorie = {
        title: "",
        status: 0,
      };
      this.showAddForm = false;
    },

    cancelEdit() {
      this.editJobCategoriesData.forEach((jobCategorie) => {
        jobCategorie.editing = false;
      });
      this.editJobCategorieData = {
        title: "",
        status: 0,
      };
      this.editFormSubmitted = false;
      if (this.sortableInstance) {
        this.sortableInstance.option("disabled", false);
      }
    },

    async deleteJobCategorie() {
      try {
        await axios.delete(
          `${API_BASE_URL}/jobcategory/${this.jobCategorieToDelete}/`
        );
        this.fetchJobCategories();
        this.fetchCounts();
        (this.$refs.dummyButton as HTMLElement).click();
      } catch (error) {
        console.error("Error deleting jobCategorie:", error);
      }
    },

    async changeJobCategorieStatus(jobCategorieId: number, status: number) {
      const newStatus = status === 1 ? 0 : 1;
      const index = this.editJobCategoriesData.findIndex(
        (cat) => cat.id === jobCategorieId
      );
      if (index !== -1) {
        const originalStatus = this.editJobCategoriesData[index].status;
        this.editJobCategoriesData[index].status = newStatus;
        this.editJobCategoriesData = [...this.editJobCategoriesData];

        try {
          const formData = new FormData();
          formData.append("status", newStatus.toString());

          await axios.patch(
            `${API_BASE_URL}/jobcategory/${jobCategorieId}/`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          Swal.fire({
            icon: "success",
            title: "Status Updated Successfully!",
            showConfirmButton: false,
            timer: 1500,
          });
        } catch (error) {
          console.error("Error updating JobCategory status:", error);
          this.editJobCategoriesData[index].status = originalStatus;
          this.editJobCategoriesData = [...this.editJobCategoriesData];
          Swal.fire({
            icon: "error",
            title: "Status Update Failed",
            text: "Reverted to original status.",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    },
    setupSortable() {
      nextTick(() => {
        const sortableList = this.$refs.sortableList as HTMLElement;
        if (!sortableList) {
          console.error("Sortable list ref not found!");
          return;
        }
        if (this.sortableInstance) {
          this.sortableInstance.destroy();
        }
        this.sortableInstance = Sortable.create(sortableList, {
          animation: 150,
          draggable: ".admin-item-box",
          ghostClass: "sortable-ghost",
          chosenClass: "sortable-chosen",
          dragClass: "sortable-drag",
          filter:
            ".css-checkbox, button, input, select, a, .admin-item-box-btm",
          preventOnFilter: true,
          disabled: this.editFormSubmitted,
          onStart: (evt: SortableEvent) => {
            this.isDragging = true;
            if (["title", "-title"].includes(this.sortBy)) {
              evt.preventDefault();
              Swal.fire({
                icon: "warning",
                title: "Cannot Drag",
                text: "First remove sorting then you can be able to drag   it.",
                timer: 2000,
                showConfirmButton: false,
              });
              return false;
            }
          },
          onEnd: async (evt: SortableEvent) => {
            this.isDragging = false;
            const oldIndex = evt.oldIndex!;
            const newIndex = evt.newIndex!;
            if (oldIndex === newIndex) return;
            const newJobCategoriesData = [...this.editJobCategoriesData];
            const [movedItem] = newJobCategoriesData.splice(oldIndex, 1);
            newJobCategoriesData.splice(newIndex, 0, movedItem);
            const totalItems = newJobCategoriesData.length;
            newJobCategoriesData.forEach((item, index) => {
              item.position = totalItems - index;
            });
            this.editJobCategoriesData = newJobCategoriesData;
            const reorderedItems = newJobCategoriesData.map((item) => ({
              id: item.id,
              position: item.position,
            }));
            try {
              await axios.post(`${API_BASE_URL}/jobcategory/reorder/`, {
                items: reorderedItems,
              });
              await this.fetchJobCategories(
                this.limit,
                (this.currentPage - 1) * this.limit
              );
              Swal.fire({
                icon: "success",
                title: "Order Updated Successfully!",
                timer: 1500,
                showConfirmButton: false,
              });
            } catch (error) {
              console.error("Error updating order:", error);
              await this.fetchJobCategories(
                this.limit,
                (this.currentPage - 1) * this.limit
              );
              Swal.fire({
                icon: "error",
                title: "Order Update Failed!",
                text: "Reverted to last saved order.",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
        });
      });
    },
    toggleStatus(isEdit: boolean) {
      if (isEdit) {
        this.editJobCategorieData.status =
          this.editJobCategorieData.status === 1 ? 0 : 1;
      } else {
        this.newJobCategorie.status = this.newJobCategorie.status === 1 ? 0 : 1;
      }
    },
    toggleSort(field: string) {
      if (this.sortBy === field) {
        this.sortBy = `-${field}`;
      } else if (this.sortBy === `-${field}`) {
        this.sortBy = "-position";
      } else {
        this.sortBy = field;
      }
      this.fetchJobCategories(
        this.limit,
        (this.currentPage - 1) * this.limit,
        this.sortBy
      );
    },
  },
});
</script>
<style scoped>
.admin-item-box-top {
  cursor: move;
}
.admin-item-box.dragging {
  opacity: 0.5;
}
</style>
